import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import filterList from 'website/containers/lists/filterlist';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userRating from 'website/containers/user-action/userRating';
import userWantToSee from 'website/containers/user-action/userWantToSee';
import affinityBadge from 'website/containers/user/affinityBadge';
import userFriendsRating from 'website/containers/user/userFriendsRating';
import initAnimatedPoster from 'website/module/advertisement/animated-poster';
import initCarouselVideo from 'website/module/advertisement/carousel-video';
import carousel from 'website/module/ui/carousel';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  carousel();
  initCarouselVideo();

  thirdNav();

  roller();

  dropdownLinks();

  filterList();

  initAnimatedPoster();

  facebookWidgets();

  // Social user Action
  userRating();
  userWantToSee();
  userFriendsRating();
  userOpinion();

  socialActionsBootstrap().then(() => {
    // to avoid having a display skip.
    // the macaron is loaded after the social request
    affinityBadge();
  });
});
